import { EFinancingCompany, PlanPromoRule } from '@if/core/types'
import { DATE_MAX } from '@src/data/types/Constants'
import { Merchant } from '@src/data/types/Merchant'
import { MerchantPaymentPlan } from '@src/data/types/MerchantPaymentPlan'
import MerchantPromoPlanPanel from './MerchantPromoPlanPanel'

interface Props {
  merchant: Merchant
  isPaymentPlanFetching: boolean
  merchantPaymentPlans: MerchantPaymentPlan[]
  planPromoRules: PlanPromoRule[]
}

const MerchantPromotionPanel = ({
  merchant,
  isPaymentPlanFetching,
  merchantPaymentPlans,
  planPromoRules,
}: Props) => {
  const thereExistsSomeActiveMerchantPaymentPlan = merchantPaymentPlans.some((plan) => {
    const today = new Date()
    const from = new Date(plan.activeFrom)
    const to = new Date(plan.expiresOn ?? DATE_MAX)
    return today >= from && today <= to
  })

  const shouldShowPromotionTab =
    merchant.financingCompanyId === EFinancingCompany.IFinance
      ? !isPaymentPlanFetching && thereExistsSomeActiveMerchantPaymentPlan
      : !isPaymentPlanFetching

  return (
    <>
      {shouldShowPromotionTab && (
        <>
          <MerchantPromoPlanPanel
            availablePaymentPlans={merchantPaymentPlans}
            initialPlanPromoRules={merchant.planPromoRules}
            planPromoRules={planPromoRules}
            supportFinancingPrograms={merchant.supportedFinancingPrograms}
          />
        </>
      )}
    </>
  )
}

export default MerchantPromotionPanel
